// Generated by scripts/generate-tstyles-themes.py -- do not edit by hand.
// The styles that ship with github.com/fcreme/TerminalStyles.

export const TSTYLES_THEMES = [
  { id: 'eva', blurb: 'Anta baka?', swatch: ['#ff3d5a', '#f4d87a', '#a8c5e8'] },
  { id: 'ex-machina', blurb: 'You\'ve been programmed and fed by another....', swatch: ['#ff7b8a', '#ffd4a8', '#6ed5ff'] },
  { id: 'forest', blurb: 'Quiet alpine wilderness', swatch: ['#e0a088', '#c8d49a', '#5aa5f0'] },
  { id: 'garden-rain', blurb: 'Ghibli-style garden rainfall', swatch: ['#c87080', '#d8c068', '#5a98d8'] },
  { id: 'golden-forest', blurb: 'Warm sepia/forest styling', swatch: ['#d4825c', '#f4c948', '#7a8a5e'] },
  { id: 'halo', blurb: 'Third in the EXT3 LED-marquee series, sister...', swatch: ['#ff8068', '#ffe860', '#6890ff'] },
  { id: 'kitty', blurb: 'Soft pastel CRT styling with a pink-lavender...', swatch: ['#ffb3c1', '#ffe4c2', '#c7d2fe'] },
  { id: 'lain', blurb: 'Serial Experiments Lain', swatch: ['#d06070', '#d8b888', '#88a8c0'] },
  { id: 'marquee', blurb: 'EXT3-series LED marquee, sister piece to...', swatch: ['#ff6098', '#ffe860', '#60a8ff'] },
  { id: 'neon-rain', blurb: 'Cyberpunk rainy night', swatch: ['#d86850', '#ffe890', '#88b0e0'] },
  { id: 'rain', blurb: 'Still no sign of the others.', swatch: ['#c87878', '#c8b850', '#9ca0cc'] },
  { id: 'snowday', blurb: 'Quiet winter sunset', swatch: ['#e89880', '#ffd8a0', '#6a90b8'] },
  { id: 'sober', blurb: 'The quiet one', swatch: ['#c87878', '#c8b898', '#9ab8b8'] },
  { id: 'tombraider', blurb: '90s arcade marquee', swatch: ['#ff5090', '#ffe860', '#60a8ff'] },
  { id: 'umbrella', blurb: 'Welcome to Umbrella Corporation. Status: FINE.', swatch: ['#e04848', '#d4b888', '#9b8e70'] },
];
